// ----------------------------------------------------------------------
// <copyright file='Izenda.ViewSetting.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import { SUB_REPORT as constants } from 'logic/data/Izenda.PropertiesBuilderConstants';
import { map } from 'lodash/fp';

@connect()
export default class ViewSetting extends Component {
  static propTypes = {
    viewSettingByLink: PropTypes.bool.isRequired,
    selectedIconValue: PropTypes.object.isRequired,
    updateSelectedViewSettingIcon: PropTypes.func.isRequired,
    updateViewSettingByLink: PropTypes.func.isRequired
  };

  selectedIcon() {
    const { selectedIconValue } = this.props;
    return (
      <a>
        <i className={selectedIconValue.icon} value={selectedIconValue.value} />
      </a>
    );
  }

  renderListIcons() {
    const props = this.props;
    const onClick = value => () => {
      props.updateSelectedViewSettingIcon(value);
    };

    return map(
      item => (
        <li className="no-padding" key={item.value} onClick={onClick(item.value)}>
          <a className={item.icon} value={item.value} />
        </li>
      ),
      constants.ICON_TYPES
    );
  }

  renderIconDropDownList() {
    const { viewSettingByLink } = this.props;
    const iconDropdownClass = classnames('form-control custom-drop-down', { disabled: viewSettingByLink });

    return (
      <div>
        <div
          ref={dom => {
            dom && $izenda(dom).dropdown();
          }}
          className={iconDropdownClass}
          data-toggle="dropdown"
          disabled={viewSettingByLink}
        >
          {this.selectedIcon()}
          <span className="icon-triangle-down pull-right" />
        </div>
        <ul className="dropdown-menu">{this.renderListIcons()}</ul>
      </div>
    );
  }

  render() {
    const props = this.props;
    const localization = props.localization;

    return (
      <div className="input-group col-md-12 border-view-setting">
        <label className="col-md-12 no-padding">{localization.getText('REPORTDESIGNER_LABEL_VIEW_SETTING_AS')}</label>
        <div className="col-md-12 no-padding">
          <input
            type="radio"
            name="viewSetting"
            checked={props.viewSettingByLink}
            onChange={props.updateViewSettingByLink}
          />
          {localization.getText('COMMON_LABEL_LINK')}
        </div>
        <div className="col-md-12 no-padding">
          <div className="col-md-2 no-padding">
            <input
              type="radio"
              name="viewSetting"
              checked={!props.viewSettingByLink}
              onChange={props.updateViewSettingByLink}
            />
            {localization.getText('COMMON_LABEL_ICON')}
          </div>
          <div className="col-md-3 no-padding">{this.renderIconDropDownList()}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ViewSetting.js